import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const collapsePressureMap = new Map();

collapsePressureMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

collapsePressureMap.set(KnowEdmTableData.CollapsePressureGradient, {
  key: KnowEdmTableData.CollapsePressureGradient,
  label: RecognisedHeaderLabels.CollapsePressureGradient,
  unit: defaultUnits.get(QuantitiesTypes.Density),
  quantity: QuantitiesTypes.Density,
});

collapsePressureMap.set(KnowEdmTableData.CollapsePressure, {
  key: KnowEdmTableData.CollapsePressure,
  label: RecognisedHeaderLabels.CollapsePressure,
  unit: defaultUnits.get(QuantitiesTypes.PressureСhange),
  quantity: QuantitiesTypes.PressureСhange,
});

export {
  collapsePressureMap,
};
